"use client";

import { useEffect } from "react";
import { useTheme } from "@/contexts/ThemeContext";
import { Post } from "@/components/Post";
import AddComment from "@/components/AddComment";
import AllComments from "@/components/AllComments";
import type { POST_BY_SLUG_QUERYResult } from "@/sanity/types";
import { token } from "@/sanity/env";

export function PostPageContent({
  post,
}: {
  post: NonNullable<POST_BY_SLUG_QUERYResult>;
}) {
  const { setTheme } = useTheme();

  // Check if post content has imageSlide
  const hasImageSlide =
    Array.isArray(post.content) &&
    post.content.some((block) => block?._type === "imageSlide");

  useEffect(() => {
    // imageSlide가 있으면 gray 테마, 없으면 light 테마
    setTheme(hasImageSlide ? "gray" : "light");

    // Cleanup: 컴포넌트가 unmount될 때 light 테마로 리셋
    return () => {
      setTheme("light");
    };
  }, [hasImageSlide, setTheme]);

  return (
    <div
      className={`site-container site-grid pt-[30px] md:pt-[50px] bg-transparent`}
    >
      <main className="site-inline-container grid-cols-1 gap-6 ">
        <Post {...post} />
        {token && post.emojiGroup.length > 0 && (
          <div className="flex flex-col gap-6">
            <AddComment {...post} />
            <AllComments comments={post.comments} />
          </div>
        )}
      </main>
    </div>
  );
}
